import { Form, Input, Modal, Spin, DatePicker } from 'antd';
import React, { memo, useCallback, useState } from 'react';
import moment from 'moment';
import Tree from '../../../../../components/tree/Tree/Tree';
import useDebouncedSearch from '../../../../../hooks/useDebouncedSearch';
import usePreparedForTreeData from '../../../hooks/usePreparedForTreeData';
import getReceipt from '../../../requests/getReceipt';
import styles from '../modalStyles.module.scss';
import warningImg from '../../../../../resource/WarningIcon.svg';
import useTreeData from '../../../queries/useTreeData';

const { MonthPicker } = DatePicker;

const DownloadReportModal = ({ onClose, visible }) => {
  const [loading, setLoading] = useState(false);
  const [selectedRooms, setSelectedRooms] = useState([]);
  const [periodDate, setPeriodDate] = useState(moment().subtract(1, 'months'));
  const [search, setSearch, debouncedSearch] = useDebouncedSearch();
  const onSearchChange = useCallback((e) => setSearch(e.target.value));
  const handlePeriodDateChange = (date) => {
    setPeriodDate(date);
  };
  const disabledDate = (current) => {
    return current && (current < moment('2022') || current > moment());
  };
  const [data, treeLoading] = usePreparedForTreeData(
    selectedRooms,
    setSelectedRooms,
    debouncedSearch,
    true
  );
  const { data: invalidData, isFetching: invalidDataLoading } = useTreeData(
    debouncedSearch,
    false
  );
  const onOk = useCallback(async () => {
    setLoading(true);
    const period = moment(periodDate)
      .startOf('month')
      .format('YYYY-MM-DDT19:00:00[Z]');

    const [url, fileName] = await getReceipt(selectedRooms, period);
    if (url) {
      const link = document.createElement('a');
      link.setAttribute('download', fileName);
      document.body.appendChild(link);
      link.href = url;
      link.click();
      onClose();
    }
    setLoading(false);
  }, [selectedRooms, periodDate]);

  return (
    <Modal
      wrapClassName='receiptModal'
      title="Выгрузка квитанций"
      visible={visible}
      onOk={onOk}
      onCancel={onClose}
      okText="Выгрузить квитанции"
    >
      <Spin spinning={invalidDataLoading}>
        {invalidData.length && (
          <div className={styles.alert}>
            <img src={warningImg} className={styles.image} />
            <div className={styles.text}>
              <div>
                Для выгрузки квитанций необходимо указать Собственника у
                следующих помещений:
              </div>

              {invalidData
                .map((el) => {
                  return el.floors.map((floor) => {
                    return floor.offices.map((office) => {
                      return office.name;
                    });
                  });
                })
                .flat(4)
                .map((office, index) => `${index + 1}. ${office}`)
                .join(' ')}
            </div>
          </div>
        )}
      </Spin>
      <Spin spinning={loading}>
        <Form.Item label="Поиск">
          <Input
            value={search}
            placeholder="Поиск по арендатору или офису"
            onChange={onSearchChange}
          />
        </Form.Item>
        <Form.Item label='Расчетный период'>
          <MonthPicker
            className={styles.datePicker}
            onChange={handlePeriodDateChange} 
            placeholder="Выберите расчетный период"
            dropdownClassName={styles.datePickerDropdown}
            getCalendarContainer={() => document.querySelector(`.receiptModal`)}
            format='MMMM YYYY'
            value={periodDate}
            disabledDate={disabledDate}
            allowClear={false}
          />
        </Form.Item>
        <Form.Item label="Объекты">
          <Spin spinning={treeLoading}>
            <div className={styles.treeContainer}>
              <Tree data={data} />
            </div>
          </Spin>
        </Form.Item>
      </Spin>
    </Modal>
  );
};

export default memo(DownloadReportModal);
